import React, {useEffect, useState} from "react";
import {
    Bookmark,
    Calendar,
    Cloud,
    FilePlus,
    Filter,
    MessageCircle
} from "react-feather";
import {ComponenteFeature} from "../Componentes/indexComponentes";
import {Container} from "../Home/styleHome";
import {
    ApresentacaoImagem,
    Container1,
    Container1Texto,
    Container2,
    ContainerHeader,
    Triangulo
} from "../Componentes/styleComponentes";
import {ImagemMonitoramento} from "./styledMonitoramento";
import monitoramentos from "../imagens/monitoramento@2x.png";
import painel from "../imagens/painel_monitoramento.png";

export const Monitoramento = ({monitoramento}) => {
    const [animacao1, setAnimacao1] = useState(true);

    const slideImg = () => {
        setInterval(() => { setAnimacao1(!animacao1)}, 10000);
    };

    useEffect(() => {
        slideImg()
    },[animacao1]);


    return (
        <Container id={"monitoramento"}>
            <ContainerHeader>
                <Container1 background={"#775C5C"}>
                    <Container1Texto paddingLeft={"100px"}>
                        <div style={{display: "flex"}}>
                            <div>
                                <MessageCircle size={"75px"} color="#e6e6e6"/>
                            </div>
                            <header>
                                <span style={{color: "#dadada"}}>MÓDULO</span>
                                <h2>MONITORAMENTO</h2>
                            </header>
                        </div>
                        <div>
                            <p>
                                Nunca mais perca oportunidades! Monitore o Chat do Pregoeiro em ambiente organizado e
                                inovador, receba alertas ou notificações por email sempre que for convocado pelo
                                pregoeiro ou quando uma palavra-chave for citada. Acompanhe no Painel de Ocorrências do
                                Dia as mensagens com ocorrência em Tempo Real!

                            </p>
                        </div>
                    </Container1Texto>


                    {animacao1 && monitoramento ?
                        <ImagemMonitoramento scroll={monitoramento}>
                            <img
                                src={monitoramentos}
                                height={"auto"}
                                width={"99%"}
                                alt={"monitoramento"}
                            />
                        </ImagemMonitoramento>
                        :

                        <ImagemMonitoramento scroll={!monitoramento}>
                            <img
                                src={painel}
                                height={"auto"}
                                width={"99%"}
                                alt={"monitoramento"}
                            />
                        </ImagemMonitoramento>
                    }



                </Container1>
                <Triangulo/>
                <Container2>
                    <ComponenteFeature
                        status={monitoramento}
                        titulo={"CADASTRO AUTOMÁTICO"}
                        subTitulo={"SINCRONIZAMOS COM O PORTAL"}
                        icone={<FilePlus/>}
                        texto={
                            "Monitoramos suas licitações no portal de compras e sempre que identificamos novas licitações a importação é feita automaticamente."
                        }
                    />
                    <ComponenteFeature
                        status={monitoramento}
                        titulo={"MONITOR NAS NUVENS"}
                        subTitulo={"MONITORE SEM ESTAR LOGADO"}
                        icone={<Cloud/>}
                        texto={
                            "Monitore as ocorrências da sua licitação 24 horas por dia."
                        }
                    />
                    <ComponenteFeature
                        status={monitoramento}
                        titulo={"OCORRÊNCIAS DO DIA"}
                        subTitulo={"VISUALIZE TODAS NOTIFICAÇÕES"}
                        icone={<Calendar/>}
                        texto={
                            "Acompanhe em tempo real todas as suas ocorrências centralizadas em uma única tela."
                        }
                    />
                    <ComponenteFeature
                        status={monitoramento}
                        titulo={"5 TIPOS DE MONITORAMENTO"}
                        subTitulo={"FIQUE POR DENTRO DE TUDO"}
                        icone={<Filter/>}
                        texto={
                            "Monitore novas mensagens, CNPJ + Razão Social, Mudanças na situação da Licitação, Palavras-chave importantes e Palavras-chave específicas da licitação."
                        }
                    />
                </Container2>
            </ContainerHeader>
        </Container>
    );
};
